export enum ItemType {
  Car = 'auto',
  Realty = 'realty',
  Others = 'others'
}
